export default __webpack_public_path__ + "static/media/right_arrow.474410f8.svg";